import React from 'react';
import PropTypes from 'prop-types';

const OneOfRadioButton = ({
  onChange,
  value,
  name,
  checked,
  disabled,
}) => (
  <input
    type="radio"
    onChange={onChange}
    onClick={() => {
      if (checked) {
        onChange({ deselectButton: true }); // deseleting the current one
      }
    }}
    value={value}
    name={name}
    checked={checked}
    disabled={disabled}
  />
);

OneOfRadioButton.defaultProps = {
  value: '',
  checked: false,
};

OneOfRadioButton.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool.isRequired,
};

export default OneOfRadioButton;
